import { AutoComplete, Col, Input, Row, Typography } from "antd";
import React, { useState } from "react";
import {
  type NetworkOption,
  type NetworkType,
} from "../redux/slices/manageUsers/manageUsersTypes";
import { useAppSelector } from "../hooks/hooks";
import { selectAvailableZones } from "../redux/slices/manageUsers/manageUsersSlice";

const { Text } = Typography;

export const AutoCompleteClient = ({
  value,
  onChange,
  initValue,
  domain,
}: {
  value?: any;
  onChange?: any;
  initValue?: NetworkType;
  domain: string;
}): JSX.Element => {
  const [searchString, setSearchString] = useState("");
  // const form = Form.useFormInstance();
  const availableZones = useAppSelector(selectAvailableZones);
  console.log("autocomplete value", value);
  const renderAutocompleteOption = (item: NetworkType): JSX.Element => {
    return (
      <Row>
        <Col flex="auto">{item.networkName}</Col>
        <Col flex="none">
          <Text type="secondary">
            id: {item.id} login: {item.networkLogin}
          </Text>
        </Col>
      </Row>
    );
  };

  const getNetworksOptions = (
    networks: NetworkType[] | undefined,
  ): NetworkOption[] => {
    if (networks == null) return [];
    if (searchString !== "")
      networks = networks.filter((item) =>
        item.networkName.toLowerCase().startsWith(searchString.toLowerCase()),
      );
    const res = networks.map((item) => {
      return {
        value: item.networkName,
        label: renderAutocompleteOption(item),
        key: item.id,
        network: item,
      };
    });
    console.log("getNetworksOptions", res);
    return res;
  };

  const onSearch = (value: string): void => {
    setSearchString(value);
  };

  return (
    <AutoComplete
      options={getNetworksOptions(availableZones[domain]?.networks)}
      style={{ width: 200 }}
      onSearch={onSearch}
      defaultValue={initValue?.networkName}
      // value={value}
      // onFocus={onSearch}
      placeholder="Выбор клиента"
      dropdownMatchSelectWidth={600}
      onSelect={(val, option: NetworkOption) => {
        console.log("NetworkType", option);
        onChange(option.network);
      }}
    >
      <Input
        value={value}
        // defaultValue={initValue?.networkName}
        allowClear
      ></Input>
    </AutoComplete>
  );
};
